import {ContractStates, UserStatuses} from '../../../types/contract.types';
import {IRequestStatuses} from '../../../types/request.types';

/* Color Constants - соответствуют CSS переменным из styles.css */
export const COLORS = {
  // Primary Blue Colors
  PRIMARY_BLUE: '#1565C0',
  PRIMARY_BLUE_HOVER: '#69AAF3',
  PRIMARY_BLUE_LIGHT: '#1170B4',
  PRIMARY_BLUE_DARK: '#083759',
  
  // Red Colors
  RED: '#E63333',
  RED_ERROR: '#ED3838',
  RED_LIGHT: '#FFE2E2',
  
  // Green Colors
  GREEN: '#019875',
  GREEN_SUCCESS: '#3AB479',
  GREEN_LIGHT: '#BFEED7',
  
  // Orange Colors
  ORANGE: '#ED9F08',
  ORANGE_WARNING: '#FFAD31',
  ORANGE_LIGHT: '#FFF0D8',
  
  // Gray Colors
  GRAY_LIGHT: '#E6E8EB',
  GRAY_MEDIUM: '#808080',
  GRAY_REGULAR: '#AAAAAA',
  GRAY_SECONDARY: '#949494',
  GRAY_STATE: '#EAECEE',
} as const;

export const getStateColors = (state) => {
  switch(state) {
    case ContractStates.DRAFT:
    case UserStatuses.NOT_SIGNED:
    case IRequestStatuses.CREATED:
      return COLORS.GRAY_STATE; //gray
    case ContractStates.IN_PROGRESS:
    case ContractStates.WAITING_FOR_APPROVAL:
    case ContractStates.WAITING_FOR_CONFIRMATION:
    case ContractStates.VERIFICATION:
    case IRequestStatuses.REQUESTED:
      return COLORS.ORANGE_LIGHT; //yellow
    case ContractStates.FAILED:
    case ContractStates.ARCHIVED:
    case ContractStates.CANCELED:
    case ContractStates.REJECTED:
    case IRequestStatuses.FINISHED:
    case IRequestStatuses.USED:
    case UserStatuses.REJECTED:
      return COLORS.RED_LIGHT; //red
    case ContractStates.SUCCESS:
    case ContractStates.DONE:
    case UserStatuses.SIGNED:
      return COLORS.GREEN_LIGHT; //green
    default:
      return COLORS.GRAY_STATE; //gray
  }
};
export const getStateTextColors = (state) => {
  switch(state) {
    case ContractStates.DRAFT:
    case UserStatuses.NOT_SIGNED:
    case IRequestStatuses.CREATED:
      return COLORS.GRAY_MEDIUM;
    case ContractStates.IN_PROGRESS:
    case ContractStates.WAITING_FOR_APPROVAL:
    case ContractStates.VERIFICATION:
    case ContractStates.WAITING_FOR_CONFIRMATION:
    case IRequestStatuses.REQUESTED:
      return COLORS.ORANGE_WARNING;
    case ContractStates.FAILED:
    case ContractStates.ARCHIVED:
    case ContractStates.CANCELED:
    case ContractStates.REJECTED:
    case IRequestStatuses.FINISHED:
    case IRequestStatuses.USED:
    case UserStatuses.REJECTED:
      return COLORS.RED_ERROR;
    case ContractStates.SUCCESS:
    case ContractStates.DONE:
    case UserStatuses.SIGNED:
      return COLORS.GREEN_SUCCESS;
    default:
      return COLORS.GRAY_MEDIUM;
  }
};
export const getStateIcons = (state) => {
  switch(state) {
    case ContractStates.DRAFT:
    case UserStatuses.NOT_SIGNED:
    case IRequestStatuses.CREATED:
      return 'assets/icons/draft-icon.svg';
    case ContractStates.IN_PROGRESS:
    case ContractStates.WAITING_FOR_APPROVAL:
    case ContractStates.WAITING_FOR_CONFIRMATION:
    case ContractStates.VERIFICATION:
    case IRequestStatuses.REQUESTED:
      return 'assets/icons/in-progress-icon.svg'; //F2C94C
    case ContractStates.FAILED:
    case ContractStates.ARCHIVED:
    case ContractStates.CANCELED:
    case ContractStates.REJECTED:
    case IRequestStatuses.FINISHED:
    case IRequestStatuses.USED:
    case UserStatuses.REJECTED:
      return 'assets/icons/reject-icon.svg';
    case ContractStates.SUCCESS:
    case ContractStates.DONE:
    case UserStatuses.SIGNED:
      return 'assets/icons/success-icon.svg';
    default:
      return '#808080';
  }
};
